import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { get } from 'lodash-es';

const Covered = ({ covered, strings }) => {
  const render = [];
  // first_name
  if (get(covered, 'party.first_name')) {
    render.push(
      <Fragment key="first_name">
        <span className="label">{get(strings, 'block.covered.party.field.first_name.label')}</span>
        <span className="item">{get(covered, 'party.first_name')}</span>
      </Fragment>
    );
  }
  // name
  if (get(covered, 'party.name')) {
    render.push(
      <Fragment key="name">
        <span className="label">{get(strings, 'block.covered.party.field.name.label')}</span>
        <span className="item">{get(covered, 'party.name')}</span>
      </Fragment>
    );
  }

  return render;
};

const CoveredSummary = ({ index, covered, strings }) => (
  <div className="summary">
    <span className="index">#{String(index + 1)}</span>
    <Covered strings={strings} covered={covered} />
  </div>
);

CoveredSummary.propTypes = {
  strings: PropTypes.objectOf(PropTypes.string),
  index: PropTypes.number.isRequired,
  // eslint-disable-next-line
  covered: PropTypes.any.isRequired,
};

CoveredSummary.defaultProps = {
  strings: {},
};

export default CoveredSummary;
